import { render, staticRenderFns } from "./ciudades.vue?vue&type=template&id=21a2f18c&"
import script from "./ciudades.vue?vue&type=script&lang=js&"
export * from "./ciudades.vue?vue&type=script&lang=js&"
import style0 from "./ciudades.vue?vue&type=style&index=0&id=21a2f18c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports